<template>


  <div style="height: 100%;">

    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>使用设置</el-breadcrumb-item>
      <el-breadcrumb-item>使用说明</el-breadcrumb-item>
    </el-breadcrumb>



    <el-card  :body-style="{  padding: '0px',paddingTop:'20px' ,paddingBottom:'200px'}"  align="center"  >



<!--      <div v-if="company.newCompanyStatus == 1">-->
<!--        <el-alert-->
<!--          title="薪资查询助手,新用户免费试用12个月!"-->
<!--          type="warning"-->
<!--          center-->
<!--          show-icon>-->
<!--        </el-alert>-->
<!--      </div>-->


        <el-collapse style="width:80%"   v-model="activeNames"  align="left">
          <el-collapse-item  title="1、使用薪资查询助手需要特定模板吗？" name="1">
            <div class="explain_info">无需按照模版上传，建议使用本公司工资表，工资表中务必包含“手机号码和实发薪资”即可，其他字段都可自定义。</div>
          </el-collapse-item>
          <el-collapse-item title="2、员工如何查看工资条？" name="2">
            <div class="explain_info">1.微信搜索小程序"薪资查询助手"，即可查看工资条。</div>
          </el-collapse-item>
          <el-collapse-item title="3、发错工资是否可以撤回？" name="3">
            <div class="explain_info">发出的工资条，可以随时撤回，撤回后员工将无法查看。</div>
          </el-collapse-item>
          <el-collapse-item title="4、我上传的薪资数据安全吗?" name="4">
            <div class="explain_info">1、薪资数据加密：所有投递给员工的工资条都经过加密处理，薪资信息不会意外泄漏。</div>
            <div class="explain_info">2、数据安全可靠：阿里云提供了稳定可靠的安全防护技术，为您的数据保驾护航。</div>
            <div class="explain_info">3、方便快捷管理：您可以随时进行新增、修改、删除等操作对薪资数据进行管理。一旦删除，我们不会以任何形式保存您工资表中的薪资数据。</div>
            <div class="explain_info">4、企业私有部署：支持企业定制薪资查询助手，独立部署私有服务，具体联系客服。</div>
          </el-collapse-item>
          <el-collapse-item title="5、如何开具发票?" name="5">
            <div class="explain_info">如需开具发票，请联系我们的客服。</div>
          </el-collapse-item>
        </el-collapse>





      <el-form ref="form" :model="form" label-width="80px" style="margin-top: 20px;width: 90%;margin-top: 40px">
        <el-input type="textarea"  :rows="4" placeholder="如果您在使用产品有遇到任何问题或者有对产品功能有更好的意见，欢迎反馈给我们" v-model="form.feedbackStr"></el-input>
        <el-form-item label=""/>
        <el-form-item>
          <el-button type="primary"  @click="onSubmit">反馈</el-button>
        </el-form-item>
      </el-form>


    </el-card>


<!--    <div style="position:relative;">-->
<!--      <div class="button-box" draggable="false" >-->
<!--        <el-tooltip class="item" effect="dark" content="联系客服" placement="top-start"  >-->
<!--          <el-image-->
<!--            style="width: 60px; height: 60px"-->
<!--            :src="url"-->
<!--          ></el-image>-->
<!--        </el-tooltip>-->

<!--      </div>-->
<!--    </div>-->



  </div>



</template>

<script>
export default {
  data () {

    return {
        company:{
          companyName:"",
          companyPhone:"",
          companyAddress:"",
          shopNumber:"",
        },
        companyUpdate:{
          companyName:"",
          companyPhone:"",
          companyAddress:""
        },
       companyDialogVisible:false,

      form:{
        feedbackStr:'',
      },
      url:'https://wssbw-images.oss-cn-hangzhou.aliyuncs.com/trademark/web/eb1b4aca-f768-49dc-bfa4-d88d632dc2ea.png',
      activeNames:['1','2']
      }
  },
  created () {
    this.getCompany();

    this.left = document.documentElement.clientWidth - 50;
    this.top = document.documentElement.clientHeight*0.8;
  },
  methods: {
    async getCompany(){
      const { data: res } = await this.$http.post('company/queryCompanyData',{})   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg);
      }
      this.company = res.data;


    },
    async updateCompany(){
      const { data: res } = await this.$http.post('company/updateCompany',this.company)   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg);
      }
      this.getCompany();
      this.companyDialogVisible = false;
    },
    goUpdate(){
      this.companyUpdate.companyName = this.company.companyName;
      this.companyUpdate.companyPhone = this.company.companyPhone;
      this.companyUpdate.companyAddress = this.company.companyAddress;
      this.companyDialogVisible = true;
    },
    async onSubmit(){


      console.log("a",this.form.feedbackStr)
      if(this.form.feedbackStr==''){
        return ;
      }

      const { data: res } = await this.$http.post('feedback/addFeedback',this.form)   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg);
      }



      this.form.feedbackStr='';
      this.$notify({
        title: '成功',
        message: '反馈成功!',
        type: 'success'
      });
    },
  }
}

</script>

<style lang="less" scoped>
  .explain_info{
    margin-left: 10px;

    color: #909399;
  }



</style>



// WEBPACK FOOTER //
// src/components/config/Explain.vue